import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-product-pic',
  templateUrl: './product-pic.component.html',
  styleUrls: ['./product-pic.component.css']
})
export class ProductPicComponent implements OnInit {
    productPictureBankKeyno;

    prodId;

    public edit?: Edit;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.productPictureBankKeyno = this.stateService.getStateParams()['productpicturebank_keyno'];
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadEdit() {
        if (!!this.productPictureBankKeyno && !!this.prodId) {
            this.edit = (await this.datatask.Post(1066, {
                productpicturebank_keyno: this.productPictureBankKeyno,
                prod_id: this.prodId
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(1067, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(1068, this.edit);

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    productpicturebank_keyno: string;
    prod_id: string;
    prod_name: string;
    full_url: string;
}
